/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReferralInvitationStatusEnum,
    ReferralInvitationStatusEnumFromJSON,
    ReferralInvitationStatusEnumToJSON,
    ReferralInvitationsDto,
    ReferralInvitationsDtoFromJSON,
    ReferralInvitationsDtoToJSON,
    ReferralLedgerDto,
    ReferralLedgerDtoFromJSON,
    ReferralLedgerDtoToJSON,
    ReferralOverviewDto,
    ReferralOverviewDtoFromJSON,
    ReferralOverviewDtoToJSON,
    ReferralResolveDto,
    ReferralResolveDtoFromJSON,
    ReferralResolveDtoToJSON,
} from '../models';

export interface ReferralControllerGetInvitationsRequest {
    status?: ReferralInvitationStatusEnum;
    limit?: number;
    offset?: number;
}

export interface ReferralControllerGetLedgerRequest {
    limit?: number;
    offset?: number;
}

export interface ReferralControllerResolveRequest {
    code: string;
}

/**
 * 
 */
export class ReferralApi extends runtime.BaseAPI {

    /**
     * Get Referral invitations
     */
    async referralControllerGetInvitationsRaw(requestParameters: ReferralControllerGetInvitationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReferralInvitationsDto>> {
        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/referral/invitations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralInvitationsDtoFromJSON(jsonValue));
    }

    /**
     * Get Referral invitations
     */
    async referralControllerGetInvitations(requestParameters: ReferralControllerGetInvitationsRequest = {}, initOverrides?: RequestInit): Promise<ReferralInvitationsDto> {
        const response = await this.referralControllerGetInvitationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Referral ledger
     */
    async referralControllerGetLedgerRaw(requestParameters: ReferralControllerGetLedgerRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReferralLedgerDto>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/referral/ledger`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralLedgerDtoFromJSON(jsonValue));
    }

    /**
     * Get Referral ledger
     */
    async referralControllerGetLedger(requestParameters: ReferralControllerGetLedgerRequest = {}, initOverrides?: RequestInit): Promise<ReferralLedgerDto> {
        const response = await this.referralControllerGetLedgerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Referral overview
     */
    async referralControllerGetOverviewRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReferralOverviewDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/referral/overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralOverviewDtoFromJSON(jsonValue));
    }

    /**
     * Get Referral overview
     */
    async referralControllerGetOverview(initOverrides?: RequestInit): Promise<ReferralOverviewDto> {
        const response = await this.referralControllerGetOverviewRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resolve a Referral code
     */
    async referralControllerResolveRaw(requestParameters: ReferralControllerResolveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReferralResolveDto>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling referralControllerResolve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/referral/resolve/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralResolveDtoFromJSON(jsonValue));
    }

    /**
     * Resolve a Referral code
     */
    async referralControllerResolve(requestParameters: ReferralControllerResolveRequest, initOverrides?: RequestInit): Promise<ReferralResolveDto> {
        const response = await this.referralControllerResolveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
